import { AdExposureAvailability, AdSummary } from './Ad'
import { AdGroupSummary } from './AdGroup'

export interface DailyBudget {
  date: string
  amount: number
  spendingAmount: number
  currency: string
}

export interface CampaignSummary {
  id: string
  sequentialId: number
  name: string
  status: CampaignStatus
  adExposureAvailability: AdExposureAvailability
  dailyBudget: DailyBudget
  adGroup: AdGroupSummary | null
  ad: AdSummary | null
}

export enum CampaignType {
  SEARCH_AD = 'SEARCH_AD',
  DISPLAY_AD = 'DISPLAY_AD',
}

export enum CampaignStatus {
  SWITCHED_ON = 'SWITCHED_ON',
  SWITCHED_OFF = 'SWITCHED_OFF',
  DELETED = 'DELETED',
}

export interface Campaign {
  id: string
  type: CampaignType
  hospitalId: number
  name: string
  dailyBudget: DailyBudget
  status: CampaignStatus
  adExposureAvailability: string
}
